import apiClient from 'core/api';
import { add, remove } from 'core/spinner/redux/actions';
import { addToaster } from 'core/toaster/redux/actions';
import AuthService from '../../../../core/auth/auth-service';

import { envs } from 'application/envHandler';
import { ToasterType } from 'core/toaster/redux/types';
import {
  ONNET_OFFNET_LIST_FAILURE,
  ONNET_OFFNET_LIST_REQUEST,
  ONNET_OFFNET_LIST_SUCCESS,
  OnnetOffnetResult,
  OnnetOffnetRow,
} from './reducer';

type ResultDataRequest = {
  ipv4Entries?: ChangesDataType
  ipv6Entries?: ChangesDataType
}

type ChangesDataType = Array<{
  entry: string
  entryStatus: string
}>

export type SelectEntryFunction = (index: number, range: string) => {
  type: string
  payload: {
    index: number
    range: string
  }
}

function request() {
  return {
    type: ONNET_OFFNET_LIST_REQUEST
  };
}

function success(payload: any) {
  return {
    type: ONNET_OFFNET_LIST_SUCCESS,
    payload: {
      opco: payload[0].opco,
      ranges: payload[0].ranges,
      rangesIpv6: payload[0]['ranges-ipv6']
    }
  };
}

function failure(payload: any) {
  return {
    type: ONNET_OFFNET_LIST_FAILURE,
    payload
  };
}

export function getUnchangedRanges(ranges: Array<OnnetOffnetRow>) {
  const unchanged = ranges.filter((range) => !range.entryStatus || range.entryStatus === 'ADD').map((range) => range.entry)
  return [...unchanged]
}

function submitSuccess(payload: OnnetOffnetResult) {
  return {
    type: ONNET_OFFNET_LIST_SUCCESS,
    payload: {
      opco: payload.opco,
      ranges: getUnchangedRanges(payload.ranges),
      rangesIpv6: getUnchangedRanges(payload.rangesIpv6),
    }
  }
}

export function execute() {
  return async (dispatch: any) => {
    dispatch(request());
    dispatch(add(ONNET_OFFNET_LIST_REQUEST, {}));
    await AuthService.refreshToken();
    const currentOpco = AuthService.getCurrentOpco();
    /* For debugging
    dispatch(remove(ONNET_OFFNET_LIST_REQUEST));
    return dispatch(success([
      {
        rangesIpv6: [
          '2001:db8::ff00:42:8330',
          '2001:db8::ff00:42:8329/64',
        ],
        ranges: [
          '192.168.0.0/16',
          '253.86.80.0/24',
          '83.240.190.0/24',
          '94.200.145.0/24',
        ],
        opco: 'vfde',
      }
    ]))
    */
    apiClient
      .get(`${envs.REACT_APP_API_URL}/onnetOffnet`, { headers: { opco: currentOpco } })
      .then(
        response => {
          dispatch(remove(ONNET_OFFNET_LIST_REQUEST));
          return dispatch(success(response.data));
        },
        rejection => {
          dispatch(remove(ONNET_OFFNET_LIST_REQUEST));
          dispatch(
            addToaster({
              title: 'home.icon_onnet_offnet',
              message: 'error_messages.VIPOC_ERROR_012',
              type: ToasterType.danger
            })
          );
          return dispatch(failure(rejection));
        }
      );
  };
}

export function getRangeEntries(ranges: Array<OnnetOffnetRow>) {
  const entries = ranges.map((range) => ({ entry: range.entry, entryStatus: range.entryStatus })).filter((range) => range.entryStatus)
  return [...entries]
}

export function submitChanges(result: OnnetOffnetResult) {
  return async (dispatch: any) => {
    const data: ResultDataRequest = {}

    const ipv4Entries = getRangeEntries(result.ranges)
    const ipv6Entries = getRangeEntries(result.rangesIpv6)

    if (ipv4Entries.length) {
      data.ipv4Entries = ipv4Entries
    }

    if (ipv6Entries.length) {
      data.ipv6Entries = ipv6Entries
    }

    dispatch(request());
    dispatch(add(ONNET_OFFNET_LIST_REQUEST, {}));
    const currentOpco = AuthService.getCurrentOpco();
    apiClient
      .put(`${envs.REACT_APP_API_URL}/onnetOffnet`, data, { headers: { opco: currentOpco } })
      .then(
        () => {
          dispatch(submitSuccess(result))
          dispatch(remove(ONNET_OFFNET_LIST_REQUEST));
        },
        rejection => {
          let errorMsg: string = 'error_messages.VIPOC_ERROR_041';
          if (rejection.response && rejection.response.data) {
            errorMsg = rejection.response.data;
          }
          dispatch(
            addToaster({
              title: 'home.icon_onnet_offnet',
              message: JSON.stringify(errorMsg),
              type: ToasterType.danger
            })
          );
          dispatch(remove(ONNET_OFFNET_LIST_REQUEST));
          return dispatch(failure(rejection));
        }
      );
  };
}
